module.exports = "\n <svg version=\"1.2\" baseProfile=\"tiny\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n \t x=\"0px\" y=\"0px\" viewBox=\"0 0 507.9 507.9\" xml:space=\"preserve\">\n   <path ng-repeat=\"part in $ctrl.parts\" ng-attr-id=\"{{part.id}}\" ng-click=\"$ctrl.checkClick(part)\" ng-attr-fill=\"{{$ctrl.checkSelected(part)}}\" ng-attr-d={{part.d}} />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/bodyDiagram/bodyDiagram.html
// module id = 64
// module chunks = 0